import {
  FluentProvider,
  PartialTheme,
  Radio,
  RadioGroup,
  RadioGroupProps,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";

import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";
import { IOption } from "../Field/DropdownField";

interface RadioGroupCustomProps {
  rcName?: string;
  theme?: string;
  rcRole?: string[];
  requireRoles?: string[];
  options?: IOption[];
}

const RadioGroupCustom = (props: RadioGroupCustomProps & RadioGroupProps) => {
  const renderTheme: PartialTheme =
    props.theme === "dark" ? webDarkTheme : webLightTheme;
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles
  );

  return props.theme ? (
    <FluentProvider
      theme={
        props.theme === "dark"
          ? webDarkTheme
          : {
              ...renderTheme,
              colorCompoundBrandStroke: "rgb(70, 101, 136)",
              colorCompoundBrandStrokeHover: "rgb(21, 51, 89)",
              colorCompoundBrandForeground1: "rgb(70, 101, 136)",
              colorCompoundBrandForeground1Hover:  "rgb(21, 51, 89)",
            }
      }
    >
      <RadioGroup {...props} disabled={props.disabled || !isCanBeVisible}>
        {props.options?.map((option) => (
          <Radio key={option.value} value={option.value} label={option.text} />
        ))}
      </RadioGroup>
    </FluentProvider>
  ) : (
    <RadioGroup {...props} />
  );
};

export default RadioGroupCustom;
